import React, { FC, ReactElement } from 'react';
import { useScrollTrigger, Slide } from '@mui/material';

interface HideOnScrollProps {
  children: ReactElement;
  /**
   * Scroll container to watch. Defaults to `window`; pass the app's custom
   * scroll element when the page doesn't scroll the window itself.
   */
  target?: HTMLElement | null;
  /**
   * Slide direction the bar enters from. `'down'` for a top-anchored header
   * (retracts up off the top edge), `'up'` for a bottom-anchored bar (retracts
   * down off the bottom edge).
   */
  direction?: 'up' | 'down';
}

/**
 * Slides its child out of view when the user scrolls down and back into view
 * when they scroll up. `useScrollTrigger` is direction-aware with hysteresis, so
 * the child stays put near the top and only reacts to real scroll intent.
 */
const HideOnScroll: FC<HideOnScrollProps> = ({ children, target, direction = 'down' }) => {
  const trigger = useScrollTrigger(target ? { target } : undefined);

  return (
    <Slide appear={false} direction={direction} in={!trigger}>
      {children}
    </Slide>
  );
};

export default HideOnScroll;
